import { jsx as _jsx } from "react/jsx-runtime";
import * as TabsPrimitive from '@radix-ui/react-tabs';
import styles from './tabs.module.css';
export const TabPanel = ({ children, label, ...otherProps }) => (_jsx(TabsPrimitive.Content, { className: styles.Panel, "data-tabs-label": label, ...otherProps, children: children }));
